export const BoticarioLogo = ({ variant = 'default' }: { variant: 'icon' | 'default' }) => {
  if (variant === 'icon') {
    return <svg />;
  }

  return (
    <svg
      width='152'
      height='22'
      viewBox='0 0 152 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_9396_3225)'>
        <path
          d='M47.0916 2.80985C42.6737 2.80985 39.0882 6.64458 39.0882 11.4049C39.0882 16.1322 42.6737 20 47.0916 20C51.5094 20 55.0949 16.1653 55.0949 11.4049C55.0629 6.64458 51.4774 2.80985 47.0916 2.80985ZM47.0916 18.3471C44.0183 18.3471 42.1935 15.7355 42.1935 11.4049C42.1935 7.04127 44.0183 4.46275 47.0916 4.46275C50.1328 4.46275 51.9576 7.07433 51.9576 11.4049C51.9576 15.7355 50.1328 18.3471 47.0916 18.3471Z'
          fill='black'
        />
        <path
          d='M55.7677 4.66148H61.6262V19.769H64.5714V4.66148H70.4619V3.00858H55.7677V4.66148Z'
          fill='black'
        />
        <path d='M76.416 3.00858H73.4388V19.7359H76.416V3.00858Z' fill='black' />
        <path
          d='M92.359 15.0741C91.3666 17.8841 88.9976 18.3138 87.685 18.3138C84.6117 18.3138 82.755 15.7353 82.755 11.4047C82.755 7.0741 84.5797 4.49558 87.685 4.49558C89.894 4.49558 91.5907 5.68567 92.327 7.76832L92.6151 8.59477L94.0557 7.8675L93.8316 7.20634C92.8392 4.42947 90.5663 2.84268 87.589 2.84268C83.1391 2.84268 79.6817 6.61129 79.6817 11.4378C79.6817 16.3303 83.0751 19.9998 87.589 19.9998C90.5983 19.9998 92.8712 18.413 93.8636 15.6692L94.0877 15.008L92.6471 14.2807L92.359 15.0741Z'
          fill='black'
        />
        <path
          d='M125.237 16.7274L124.372 14.1819C124.052 13.2563 123.412 12.496 122.547 11.9671C124.084 11.2728 125.429 9.95053 125.429 7.86788C125.429 4.8596 123.028 3.04141 119.026 3.04141H112.975V19.7688H115.953V12.6613H118.546C120.435 12.6613 121.043 13.4216 121.587 14.9423L122.419 17.3555C122.708 18.2481 122.996 18.9092 123.348 19.4382L123.572 19.7688H127.574L126.165 18.4134C125.813 18.0828 125.493 17.4877 125.237 16.7274ZM115.953 4.66125H118.802C121.299 4.66125 122.355 5.61994 122.355 7.86788C122.355 10.0497 121.267 11.0084 118.834 11.0084H115.953V4.66125Z'
          fill='black'
        />
        <path d='M132.728 3.00858H129.75V19.7359H132.728V3.00858Z' fill='black' />
        <path
          d='M143.997 2.80985C139.579 2.80985 135.993 6.64458 135.993 11.4049C135.993 16.1322 139.579 20 143.997 20C148.414 20 152 16.1653 152 11.4049C151.968 6.64458 148.382 2.80985 143.997 2.80985ZM143.997 4.42969C147.038 4.42969 148.863 7.04127 148.863 11.3719C148.863 15.7355 147.038 18.314 143.997 18.314C140.923 18.314 139.099 15.7025 139.099 11.3719C139.067 7.04127 140.923 4.42969 143.997 4.42969Z'
          fill='black'
        />
        <path
          d='M8.00337 2.80985C3.58551 2.80985 0 6.64458 0 11.4049C0 16.1322 3.58551 20 8.00337 20C12.4212 20 16.0067 16.1653 16.0067 11.4049C16.0067 6.64458 12.4212 2.80985 8.00337 2.80985ZM8.00337 18.3471C4.93008 18.3471 3.10531 15.7355 3.10531 11.4049C3.10531 7.04127 4.93008 4.46275 8.00337 4.46275C11.0447 4.46275 12.8694 7.07433 12.8694 11.4049C12.8694 15.7355 11.0447 18.3471 8.00337 18.3471Z'
          fill='black'
        />
        <path
          d='M32.7817 9.58681C34.3823 8.72731 35.5348 7.27276 35.5348 5.32234C35.5348 1.95042 32.9417 0 28.4598 0H19.9763V19.9009H29.1641C33.582 19.9009 36.3031 17.7521 36.3031 14.2811C36.3031 11.967 34.7665 10.4133 32.7817 9.58681ZM28.5559 8.82648H23.2737V1.6529H28.2678C31.0849 1.6529 32.2694 2.74381 32.2694 5.32234C32.2374 7.76863 31.149 8.82648 28.5559 8.82648ZM23.2737 18.2811V10.4794H28.5239C30.1886 10.4794 32.9417 10.9752 32.9417 14.3472C32.9417 17.091 31.7252 18.2811 28.908 18.2811H23.2737Z'
          fill='black'
        />
        <path
          d='M104.812 0.36376H103.083L94.8877 19.7688H96.6164L99.0494 14.0828H104.908L107.405 19.7688H110.574L103.467 3.60344L104.812 0.36376ZM99.7217 12.4299L101.899 7.27288L104.172 12.4299H99.7217Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_9396_3225'>
          <rect width='152' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
